import React from 'react';

const PageContainer = ({ children }) => <div style={{ padding: '24px 20px' }}>{children}</div>;

export default PageContainer;
